/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignFormRequest,
  InspectionFormResponse,
  SaveAnswersRequest,
  SectionAnswerDto,
  UpdateFormStatusRequest,
} from '../models/index';
import {
    AssignFormRequestFromJSON,
    AssignFormRequestToJSON,
    InspectionFormResponseFromJSON,
    InspectionFormResponseToJSON,
    SaveAnswersRequestFromJSON,
    SaveAnswersRequestToJSON,
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoToJSON,
    UpdateFormStatusRequestFromJSON,
    UpdateFormStatusRequestToJSON,
} from '../models/index';

export interface AssignFormOperationRequest {
    assignFormRequest: AssignFormRequest;
}

export interface GetAnswersRequest {
    id: string;
}

export interface GetFormByIdRequest {
    id: string;
}

export interface GetFormsByOperatorRequest {
    operatorId: string;
}

export interface SaveAnswersOperationRequest {
    id: string;
    saveAnswersRequest: SaveAnswersRequest;
}

export interface UpdateFormStatusOperationRequest {
    id: string;
    updateFormStatusRequest: UpdateFormStatusRequest;
}

/**
 * 
 */
export class InspectionFormsApi extends runtime.BaseAPI {

    /**
     * Generates a new inspection form from the template\'s active published version and assigns it directly to the specified operator. This is a one-time action, not linked to any schedule. The form is created with PENDING status.
     * Assign a form to an operator (one-time)
     */
    async assignFormRaw(requestParameters: AssignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        if (requestParameters['assignFormRequest'] == null) {
            throw new runtime.RequiredError(
                'assignFormRequest',
                'Required parameter "assignFormRequest" was null or undefined when calling assignForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/forms/assign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignFormRequestToJSON(requestParameters['assignFormRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Generates a new inspection form from the template\'s active published version and assigns it directly to the specified operator. This is a one-time action, not linked to any schedule. The form is created with PENDING status.
     * Assign a form to an operator (one-time)
     */
    async assignForm(requestParameters: AssignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.assignFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all saved answers for a form instance. Returns an empty list if no answers have been saved yet.
     * Get saved answers
     */
    async getAnswersRaw(requestParameters: GetAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionAnswerDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/forms/{id}/answers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionAnswerDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all saved answers for a form instance. Returns an empty list if no answers have been saved yet.
     * Get saved answers
     */
    async getAnswers(requestParameters: GetAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionAnswerDto> {
        const response = await this.getAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a single inspection form instance by its identifier, including all sections with their questions, types, and threshold configurations.
     * Get form instance by ID
     */
    async getFormByIdRaw(requestParameters: GetFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFormById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/forms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single inspection form instance by its identifier, including all sections with their questions, types, and threshold configurations.
     * Get form instance by ID
     */
    async getFormById(requestParameters: GetFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.getFormByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all inspection form instances assigned to a specific operator, ordered by generation time. Includes sections for each form.
     * Get form instances by operator ID
     */
    async getFormsByOperatorRaw(requestParameters: GetFormsByOperatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        if (requestParameters['operatorId'] == null) {
            throw new runtime.RequiredError(
                'operatorId',
                'Required parameter "operatorId" was null or undefined when calling getFormsByOperator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/forms/operator/{operatorId}`.replace(`{${"operatorId"}}`, encodeURIComponent(String(requestParameters['operatorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all inspection form instances assigned to a specific operator, ordered by generation time. Includes sections for each form.
     * Get form instances by operator ID
     */
    async getFormsByOperator(requestParameters: GetFormsByOperatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.getFormsByOperatorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves answers for a form instance (partial or complete). Can be called multiple times — existing answers for the same section are updated (upsert). Automatically transitions PENDING forms to IN_PROGRESS on first save. Rejects saves on COMPLETED or CANCELLED forms.
     * Save answers
     */
    async saveAnswersRaw(requestParameters: SaveAnswersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionAnswerDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveAnswers().'
            );
        }

        if (requestParameters['saveAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAnswersRequest',
                'Required parameter "saveAnswersRequest" was null or undefined when calling saveAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/forms/{id}/answers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAnswersRequestToJSON(requestParameters['saveAnswersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionAnswerDtoFromJSON(jsonValue));
    }

    /**
     * Saves answers for a form instance (partial or complete). Can be called multiple times — existing answers for the same section are updated (upsert). Automatically transitions PENDING forms to IN_PROGRESS on first save. Rejects saves on COMPLETED or CANCELLED forms.
     * Save answers
     */
    async saveAnswers(requestParameters: SaveAnswersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionAnswerDto> {
        const response = await this.saveAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the status of an inspection form instance. Valid transitions are: PENDING→IN_PROGRESS, PENDING→OVERDUE, IN_PROGRESS→COMPLETED, OVERDUE→CANCELLED, OVERDUE→IN_PROGRESS. Invalid transitions return 422 Unprocessable Entity. Transitioning to COMPLETED automatically sets the completedAt timestamp.
     * Update form instance status
     */
    async updateFormStatusRaw(requestParameters: UpdateFormStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFormStatus().'
            );
        }

        if (requestParameters['updateFormStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFormStatusRequest',
                'Required parameter "updateFormStatusRequest" was null or undefined when calling updateFormStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/forms/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFormStatusRequestToJSON(requestParameters['updateFormStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Updates the status of an inspection form instance. Valid transitions are: PENDING→IN_PROGRESS, PENDING→OVERDUE, IN_PROGRESS→COMPLETED, OVERDUE→CANCELLED, OVERDUE→IN_PROGRESS. Invalid transitions return 422 Unprocessable Entity. Transitioning to COMPLETED automatically sets the completedAt timestamp.
     * Update form instance status
     */
    async updateFormStatus(requestParameters: UpdateFormStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.updateFormStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
